<template>
  <div class="tuolele-main-box sort-management-detail">
    <div class="tuolele-main-search tuolele-main-search-item">
      <el-form :inline="true" :model="myHomeWorkListQuery" class="fn-clear">
        <!-- <el-form-item label="" class="fn-left">
          <el-date-picker
            v-model="myHomeWorkListQuery.all_time"
            type="daterange"
            range-separator="至"
            :picker-options="pickerDisabled"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="calendarChange"
          />
        </el-form-item> -->
        <el-form-item label="" class="fn-left">
          <Select key="10" :selected.sync="myHomeWorkListQuery.grade_id" :data="gradeLists" clearable placeholder="请选择年级" />
        </el-form-item>
        <el-form-item label="" class="fn-left">
          <Select key="11" :selected.sync="myHomeWorkListQuery.subject_id" :data="subjectLists" clearable placeholder="请选择科目" />
        </el-form-item>
        <el-form-item label="" class="fn-left">
          <el-button type="primary" @click="searchQuestion()">查询</el-button>
        </el-form-item>
        <el-form-item label="" class="fn-right">
          <el-button type="warning" @click="createHomework()">创建练习题</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
      >
      <el-table-column prop="status_name" width="100" label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == 2" size="mini" type="success" @click="downloadFile(scope.row)">下载习题</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" width="100" label="创建时间" />
        <el-table-column prop="editor_name" width="100" label="操作人" />
        <el-table-column prop="title" label="练习标题" />
        <el-table-column prop="grade_name" width="90" label="年级" />
        <el-table-column prop="subject_name" width="90" label="科目" />
        <el-table-column width="90" prop="q_num" label="题目数" />

        <el-table-column prop="status_name" width="120" label="状态" />
        
        
      </el-table>
      <div class="footer pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="myHomeWorkListQuery.p"
            prev-text="上一页"
            next-text="下一页"
            :total="myHomeWorkListQuery.total"
            :page-size="myHomeWorkListQuery.limit"
            @current-change="searchQuestion()"
          >
            <div class="chax">
              {{ myHomeWorkListQuery.p }}/{{
                myHomeWorkListQuery.total > 0 ? Math.ceil(myHomeWorkListQuery.total / myHomeWorkListQuery.limit) : 1
              }}
            </div>
          </el-pagination>
          <div class="insert">
            <el-button type="primary">确定</el-button>
            <span class="pagination-count">
              符合查询结果:
              <i>{{ myHomeWorkListQuery.total }}条</i>
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

// const {
//   time: '',
//   begin_time: '',
//   all_time: '',
//   end_time: '',
//   grade_id: '',
//   subject_id: '',
//   error_num: ''
// }

import FileSaver from 'file-saver'

const myHomeWorkListQueryDefault = {
  p: 0,
  grade_id: '',
  subject_id: '',
  limit: 20,
  total: 0
}

import Select from '@/components/Select'

export default {
  name: 'CreateHomeWorkLists',
  components: { Select },
  data() {
    return {
      tableData: [],
      gradeLists: [],
      subjectLists: [],
      myHomeWorkListQuery: Object.assign({}, myHomeWorkListQueryDefault)
    }
  },
  mounted() {
    this.searchQuestion()
  },
  methods: {
    searchQuestion() {
      this.$http.getTeacherExercisesList(this.myHomeWorkListQuery).then(res => {
        this.gradeLists = []
        this.subjectLists = []
        this.myHomeWorkListQuery.total = parseInt(res.data.count || '0')
        this.tableData = res.data.list
        Object.keys(res.data.grade).forEach((key) => { this.gradeLists.push({ id: key, name: res.data.grade[key] }) })
        Object.keys(res.data.subject).forEach((key) => { this.subjectLists.push({ id: key, name: res.data.subject[key] }) })
      })
    },
    createHomework() {
      this.$router.push({
        path: 'createHomework'
      })
    },
    downloadFile(item) {
      FileSaver.saveAs(item.pdf_url, `${item.title}.pdf`)
    }
  }
}
</script>

<style lang="scss">
.sort-management-detail {
  .tuolele-main-search {
    padding-bottom: 20px;
  }
  .add-content-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    .add-content-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #333;
      opacity: 0.7;
    }
  }
  .add-content {
    width: 620px;
    background-color: #ffffff;
    box-shadow: 0px 6px 20px 0px rgba(148, 148, 148, 0.5);
    border-radius: 10px;
    .add-header {
      width: 100%;
      padding: 25px 30px;
      border-bottom: 1px solid #f5f5f5;
      .title {
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        color: #4c84ff;
      }
      .close {
        cursor: pointer;
        img {
          width: 18px;
          height: 18px;
        }
      }
    }
    .el-table tr th {
      background: #fff;
      color: #333;
    }
    .el-table td,
    .el-table th {
      border: 1px solid #ebebeb !important;
    }
  }
  .input1 {
    width: 211px;
    margin-right: 10px;
  }
  .add-content-main {
    display: flex;
    flex-direction: column;
    padding: 30px;
  }
  .add-content-table {
    margin: 20px auto;
  }
  .confirm-btn {
    margin: 50px 0 30px;
    .title {
      color: $color_black;
      margin-bottom: 10px;
      span {
        color: $color_blue;
      }
    }
  }
}
</style>
